import { render, staticRenderFns } from "./FpuiIconSelect.vue?vue&type=template&id=12b08c52&lang=pug&"
import script from "./FpuiIconSelect.vue?vue&type=script&lang=js&"
export * from "./FpuiIconSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports